import { __rest } from 'tslib';
import React from 'react';
import styled from 'styled-components';

var agnosticStyled = styled((_a) => {
    var { tag = 'div', children } = _a, props = __rest(_a, ["tag", "children"]);
    return React.createElement(tag, props, children);
});

export { agnosticStyled as default };
//# sourceMappingURL=agnosticStyled.mjs.map
